import {
	Select as ArcoSelect,
	SelectProps as ArcoSelectProps,
} from '@arco-design/web-react';
import { merge } from 'lodash';
import React, { useCallback } from 'react';

export interface SelectOption {
	value: string;
	label: React.ReactNode;
}

export interface SelectProps extends ArcoSelectProps {
	options: SelectOption[];
	onChange?: (val: string) => void;
	value: string;
}

export function Select(props: SelectProps) {
	const { options, ...arcoSelectProps } = props;
	const dropdownMenuClassName = [
		'bay-email-overlay',
		arcoSelectProps.dropdownMenuClassName,
	]
		.filter(Boolean)
		.join(' ');

	const clearTitleAttributes = useCallback((element: HTMLElement | null) => {
		if (!element) {
			return;
		}

		if (element.hasAttribute('title')) {
			element.removeAttribute('title');
		}

		element.querySelectorAll('[title]').forEach(node => {
			node.removeAttribute('title');
		});
	}, []);

	const onMouseEnterCapture = useCallback(
		(event: React.MouseEvent<HTMLElement>) => {
			clearTitleAttributes(event.currentTarget);
			props.onMouseEnterCapture?.(event);
		},
		[clearTitleAttributes, props],
	);

	const onFocusCapture = useCallback(
		(event: React.FocusEvent<HTMLElement>) => {
			clearTitleAttributes(event.currentTarget);
			props.onFocusCapture?.(event);
		},
		[clearTitleAttributes, props],
	);

	return (
		<ArcoSelect
			{...arcoSelectProps}
			dropdownMenuClassName={dropdownMenuClassName}
			style={merge({ width: '100%' }, arcoSelectProps.style)}
			value={arcoSelectProps.value}
			onChange={arcoSelectProps.onChange}
			onMouseEnterCapture={onMouseEnterCapture}
			onFocusCapture={onFocusCapture}
			triggerProps={merge(
				{
					position: 'bl' as const,
					autoFitPosition: true,
					autoFitTransformOrigin: true,
					updateOnScroll: true,
				},
				props.triggerProps,
			)}
			getPopupContainer={() => document.body}
		>
			{options.map(item => (
				<ArcoSelect.Option
					key={item.value}
					value={item.value}
					className='bay-email-select-option'
				>
					{item.label}
				</ArcoSelect.Option>
			))}
		</ArcoSelect>
	);
}
